import './App.css';
import React from "react";
import Button from 'react-bootstrap/Button';

import Player from './sound/Player';
import Script from './scripts/script'
import { SpeedControl } from "./components/speedcontrol"
import { SonificationSelection } from './components/sonificationselection'

function App() {
    const [isPlaying, setIsPlaying] = React.useState(false);
    const [sonificationSpeed, setSonificationSpeed] = React.useState(1.0);
    const [narrationSpeed, setNarrationSpeed] = React.useState(1.0);
    const [sonification, setSonification] = React.useState('melb20201205');
    const [playIntro, setPlayIntro] = React.useState(true);

    const player = new Player(Script);

    React.useEffect(() => {
        if (isPlaying) {
            player.play({ sonificationSpeed, narrationSpeed, playIntro }, `./data/${sonification}.json`);
            setIsPlaying(false)
        }
    }, [isPlaying]);

    const play = () => {
        setIsPlaying(true)
    }

    const changeSonificationSpeed = (ev) => {
        setSonificationSpeed(parseFloat(ev.target.value))
    }

    const changeNarrationSpeed = (ev) => {
        setNarrationSpeed(parseFloat(ev.target.value))
    }

    const changeSonification = (ev) => {
        setSonification(ev.target.value)
    }

    const changeIntro = (ev) => {
        setPlayIntro(ev.target.checked)
        return true;
    }

    return (
        <div className="App">
            <header className="App-header">
                <p>
                    <Button as="input"
                            size="lg"
                            disabled={isPlaying}
                            type="button"
                            value="Play"
                            onClick={play}/>{' '}
                </p>
                <p>
                    <label>Play Intro</label><input type="checkbox" checked={playIntro} onChange={changeIntro}/>
                </p>
                <p>
                    <SonificationSelection onChange={changeSonification}/>
                </p>
                <p>
                    <SpeedControl min={0.8} max={1.2} label="Narration speed" onChange={changeNarrationSpeed}/>
                </p>
                <p>
                    <SpeedControl min={0.5} max={2} label="Sonification speed" onChange={changeSonificationSpeed}/>
                </p>
            </header>
        </div>
    );
}



export default App;
